import axios from 'axios';

import { tokenStore } from './tokenStore';

const baseURL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3001') + '/api/v1';

export const apiClient = axios.create({
  baseURL,
  withCredentials: true,
});

// Add Authorization header with Bearer token if available
apiClient.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (
      typeof window !== 'undefined' &&
      axios.isAxiosError(error) &&
      error.response?.status === 401 &&
      window.location.pathname !== '/login' &&
      window.location.pathname !== '/register'
    ) {
      const next = `${window.location.pathname}${window.location.search}`;
      window.location.assign(`/login?next=${encodeURIComponent(next)}`);
    }
    return Promise.reject(error);
  },
);
